import React from 'react';
import ShowContainer from '../ShowContainer';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoaderContainer from '../loader_container/LoaderContainer';

export default function ShowContentWitchEmpty({
  condition,
  conditionPlug,
  children,
  plugText = 'No records found.',
  plug,
  isBox,
  plugContainerSx = {},
  loader
}) {
  const { t } = useTranslation();

  return (
    <LoaderContainer loader={loader} isBox={isBox}>
      <ShowContainer
        condition={condition}
        plug={
          <ShowContainer condition={conditionPlug}>
            <Box
              sx={{
                backgroundColor: 'grey.100',
                px: 2,
                py: 3,
                textAlign: 'center',
                ...plugContainerSx
              }}>
              {plug || <Typography color="textSecondary">{t(plugText)}</Typography>}
            </Box>
          </ShowContainer>
        }>
        {children}
      </ShowContainer>
    </LoaderContainer>
  );
}
